export const CON_DOCUMENTO = 'CON'
export const SIN_DOCUMENTO = 'SIN'

export const __dictionary = {
  [CON_DOCUMENTO]: {
    id: CON_DOCUMENTO,
    nombre: 'CON DOCUMENTO'
  },
  [SIN_DOCUMENTO]: {
    id: SIN_DOCUMENTO,
    nombre: 'SIN DOCUMENTO'
  }
}

export const __array = [__dictionary[CON_DOCUMENTO], __dictionary[SIN_DOCUMENTO]]
